import type { User } from "oidc-client-ts";

const { VITE_CLIENT_ID, VITE_AUTH_BASE_URL, VITE_REALM } = import.meta.env;

const authStorageKey = `oidc.user:${VITE_AUTH_BASE_URL}/auth/realms/${VITE_REALM}:${VITE_CLIENT_ID}`;

const getCachedUser = (): User | null => {
  const authObjectRaw = sessionStorage.getItem(authStorageKey);
  return authObjectRaw ? (JSON.parse(authObjectRaw) as User) : null;
};

export const OIDCSessionService = {
  getCachedUser,
};
